import ObsidianHomeImg from '../../assets/images/theme_obsidian/home.svg'
import ObsidianPaymentPromiseImg from '../../assets/images/theme_obsidian/payment-promise.svg'
import ObsidianInvoiceDetailImg from '../../assets/images/theme_obsidian/invoice-detail.svg'

import MethystHomeImg from '../../assets/images/theme_methyst/home.svg'
import MethystPaymentPromiseImg from '../../assets/images/theme_methyst/payment-promise.svg'
import MethystInvoiceDetailImg from '../../assets/images/theme_methyst/invoice-detail.svg'

import { ITheme, IThemeImgsProps, ThemeChoices } from './types'

export const THEME_ID_SCREEN_HOME = 'home'
export const THEME_ID_SCREEN_PAYMENT_PROMISE = 'payment-promise'
export const THEME_ID_SCREEN_INVOICE_DETAIL = 'invoice-detail'

export const THEMES: ITheme[] = [
  {
    title: 'Obsidian',
    subTitle: 'Default',
    id: ThemeChoices.THEME_ID_OBSIDIAN,
  },
  {
    title: 'Amethyst',
    subTitle: 'Light',
    id: ThemeChoices.THEME_ID_METHYST,
  },
]

export const THEMES_IMGS: Record<string, IThemeImgsProps[]> = {
  [ThemeChoices.THEME_ID_OBSIDIAN]: [
    { id: THEME_ID_SCREEN_HOME, img: ObsidianHomeImg },
    { id: THEME_ID_SCREEN_PAYMENT_PROMISE, img: ObsidianPaymentPromiseImg },
    { id: THEME_ID_SCREEN_INVOICE_DETAIL, img: ObsidianInvoiceDetailImg },
  ],
  [ThemeChoices.THEME_ID_METHYST]: [
    { id: THEME_ID_SCREEN_HOME, img: MethystHomeImg },
    { id: THEME_ID_SCREEN_PAYMENT_PROMISE, img: MethystPaymentPromiseImg },
    { id: THEME_ID_SCREEN_INVOICE_DETAIL, img: MethystInvoiceDetailImg },
  ],
}
